<template>
	<div class="teachclass_wrap" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
		<div class="teachclass_cont">
			<div class="seach_ipt">
				<el-input v-model="className" placeholder="请输入班级名称"></el-input>
				<div class="select">
					<span>班级状态</span><i></i>
					<el-select v-model="status" placeholder="请选择">
				    <el-option
				      v-for="item in options"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				  </el-select>
				</div>
				<el-button type="primary" icon="el-icon-search" @click="sreach()">查询</el-button>
				<el-button type="primary" style="float: right;" @click="addClass()">创建班级</el-button>
			</div>
			<div class="table" :style="'height:'+height" v-if="tableData.length">
				<div class="header_title">
					<p>序号</p>
					<p>班级名称</p>
					<p>学生数量</p>
					<p class="flex_cont">邀请码
						<el-tooltip class="item" effect="light" placement="right">
							<div slot="content">学生可输入教学班<br/>邀请码加入班级</div>
				      <img src="../../../../../static/images/course/teachClassIcon/tip.png"/>
				    </el-tooltip>
					</p>
					<p>开课日期</p>
					<p>班级状态</p>
					<p>操作</p>
				</div>
				<div class="teach_class">
					<li class="tab_item" v-for="(item,index) in tableData" :key="item.id">
						<p>{{index*1 < 9 ? '0' + (index*1 + 1) : index*1 + 1}}</p>
						<p>{{item.className}}</p>
						<p>{{item.studentNum}}</p>
						<p>{{item.invitCode}}</p>
						<p>{{item.startDate.slice(0,10)}} ~ {{item.endDate.slice(0,10)}}</p>
						<p>{{handleClassStatus(item.classStatus)}}</p>
						<p class="operation">
	      			<span class="into" @click="enterClass(item)">进入</span>
	            <span class="edit" @click="editorClass(item)">编辑</span>
	            <span class="end" @click="intoStudent(item)">学员</span>
	            <span class="group" @click="intoGroup(item)" v-if="productFlag == 3 || productFlag == 4">小组</span>
	            <span class="del" @click="delClass(item)">删除</span>
	      		</p>
					</li>
				</div>
			</div>
			<div class="noList" :style="'height:'+height" v-else>
				<img src="../../../../../static/images/common/noorder_pic.png"/>
				<p>暂无教学班</p>
			</div>
		</div>
		<!--创建和编辑班级-->
		<el-drawer
		  title="创建班级"
		  :visible.sync="drawer"
		  :direction="direction"
		  :close-on-press-escape="false"
		  :wrapperClosable="false"
		  :with-header="false">
		  <div class="drawer_content">
		  	<header>
		  		<span>{{titleClass}}</span><img @click="close()" src="../../../../../static/images/close.png"/>
		  	</header>
		  	<div class="ipt">
		  		<p>班级名称：</p>
		  		<el-input class="ipt_name" v-model.trim="classAddName" maxlength="20" placeholder="请输入班级名称"></el-input>
		  	</div>
		  	<div class="ipt ipt_data">
		  		<p>开课时间：</p>
		  		<div class="time_block">
		  			<el-date-picker
	            v-model="classStartTime"
	            type="date"
	            value-format="yyyy-MM-dd"
	            placeholder="请选择开始时间"
	            @change="changeEnd"
	            :picker-options="startDateLimit">
	          </el-date-picker>
	          <span>——</span>
	          <el-date-picker
	            v-model="classEndTime"
	            type="date"
	            @focus="changeEnd"
	            @change="setTime"
	            value-format="yyyy-MM-dd"
	            placeholder="请选择结束时间"
	            :picker-options="endDateLimit">
	          </el-date-picker>
		  		</div>
		  	</div>
		  	<div class="btn">
		  		<el-button @click="close()">取消</el-button>
					<el-button type="primary" @click="save()">保存</el-button>
		  	</div>
		  </div>
		</el-drawer>
	</div>
</template>

<script>
	import Pagination from "../../../paginator/paginator.vue";
	import * as api from "../../../../api/individualApi";
	import studentadmin from "./studentAdmin.vue";
	export default {
		components: {
	    Pagination,
	    studentadmin
	  },
		data(){
			return {
				className:'',
				options: [{
					label: '全部',
          value: ''
        },{
					label: '未开始',
          value: '0'
        }, {
        	label: '进行中',
          value: '1'
        }, {
        	label: '已结束',
          value: '2'
        }],
        status: '',
        tableData: [],
        height:window.innerHeight - 268+"px",
	      pageTotal: {
	        currentPage: 1,
	        pageSize: 10,
	        total: 0
	      },
	      drawer: false,
        direction: 'rtl',
        classAddName:'',
        startDateLimit:{
          disabledDate:(time)=>{
            if (this.classEndTime) {
              return time.getTime() > new Date(this.classEndTime).getTime();
            }else{//还没有选择结束时间的时候，让他只能选择今天之后的时间包括今天
              // return time.getTime() < Date.now() - 8.64e7
            } 
          }
        },
        endDateLimit:null,
        classStartTime:'',
        classEndTime:'',
        titleClass:'',
        classId:'',
        productFlag: sessionStorage.getItem('productFlag'),
				prodId: sessionStorage.getItem('prodId'),
        loading: true
			}
		},
		created(){
			this.getTeachClass();
		},
		methods:{
			// 获取教学班
			getTeachClass(){
				let obj = {
					"courseId": this.$route.query.courseId,
					"name": this.className,
					"status": this.status,
					"courseProfessional": sessionStorage.getItem('professional'),
					"type": this.productFlag,
					"courseType": this.productFlag==4?4:3,
					"prodId": this.prodId
				}
				api.getTeachClass(obj).then(res=>{
					// console.log(res);
					if(res.code == 0){
						this.tableData = res.data;
						this.loading = false
					}
				})
			},
			sreach(){
				this.loading = true;
				this.getTeachClass();
			},
			handleCurrentChange(val) {
				this.loading = true;
	      this.pageTotal.currentPage = val;
	      this.getTeachClass();
	   	},
	   	handleSizeChange(val){
	   		this.loading = true;
	   		this.pageTotal.pageSize = val;
	   		this.pageTotal.currentPage = 1;
	      this.getStudentList();
	   	},
		  //创建班级
		  addClass(){
		   	this.drawer = true;
		   	this.classAddName = '';
		   	this.classStartTime = '';
		   	this.classEndTime = '';
		   	this.titleClass = '创建班级';
      },
      // 进入班级
      enterClass(item){
        let userType = sessionStorage.getItem('userType')
      	if(userType==0 || userType==1){
          this.enterClassJump(item)
        }else{
          if(item.classStatus == 1){
            this.enterClassJump(item)
          }else if(item.classStatus == 2){
            this.$messageWarning('课程已结束。。。');
            return;
          }else if(item.classStatus == 0){
            this.$messageWarning('课程未开始。。。');
            return;
          }
        }
      },
      enterClassJump(item){
        sessionStorage.setItem('isPreview', false)
        sessionStorage.setItem('courseType', item.type)
        sessionStorage.setItem('subjectId',item.subjectId)
        let path = ''
        if(this.productFlag==4){
          path = '/switch/studentTask'
        }else{
          path = '/switch/courseware/courseDetail'
        }
        const { href } = this.$router.resolve({
          path: path,
          query: {
            id: item.courseId,
            classId: item.classId,
            className: item.className,
            classStatus: item.classStatus,
            courseName: item.courseName,
            courseType: item.courseType,
            type: item.type,
            isPay: item.isPay,
            courseModel: item.courseModel,
          }
        });
        window.open(href, '_blank');
      },
		  // 编辑班级
		  editorClass(item){
		  	this.drawer = true;
		   	this.classAddName = item.className;
		   	this.classStartTime = item.startDate.slice(0,10);
		   	this.classEndTime = item.endDate.slice(0,10);
		   	this.titleClass = '编辑班级';
		   	this.classId = item.classId;
		  },
		  // 创建或编辑班级保存
		  save(){
		  	if(!this.classAddName){
		  		this.$messageError('请填写班级名称');
					return;
		  	}
		  	if(!this.classStartTime){
		  		this.$messageError('请选择开始日期');
					return;
		  	}
		  	if(!this.classEndTime){
		  		this.$messageError('请选择结束日期');
					return;
		  	}
		  	if(this.titleClass == '创建班级'){
		  		let obj = {
	          "courseId": this.$route.query.courseId,
	          "startDate": this.classStartTime,
	          "endDate": this.classEndTime,
	          "name": this.classAddName
	        }
			  	api.addClass(obj).then(res=>{
			  		// console.log(res);
			  		if(res.code == 0){
			  			this.drawer = false;
			  			this.getTeachClass();
			  			this.$messageSuccess('创建成功');
			  		}else{
							this.$messageError(res.msg);
						}
			  	})
		  	}else if(this.titleClass == '编辑班级'){
		  		let obj = {
		  			"id": this.classId,
	          "courseId": this.$route.query.courseId,
	          "startDate": this.classStartTime,
	          "endDate": this.classEndTime,
	          "name": this.classAddName
	        }
			  	api.updateTeachClass(obj).then(res=>{
			  		// console.log(res);
			  		if(res.code == 0){
			  			this.drawer = false;
			  			this.getTeachClass();
			  			this.$messageSuccess('编辑成功');
			  		}else{
							this.$messageError(res.msg);
						}
			  	})
		  	}
		  },
		  // 删除班级
		  delClass(item){
		  	this.$tipsDialog(
					"提示",
      		"确定删除该教学班吗？",
			    "",
			    "el-icon-warning",
			    "rgb(255, 178, 60)"
				).then(() => {
					api.delTeachClass(item.classId).then(res=>{
			  		// console.log(res);
			  		if(res.code == 0){
			  			this.getTeachClass();
			  			this.$messageSuccess('删除成功');
			  		}
			  	}).catch(error => {});
       	}).catch(() => {});
		  },
		  // 关闭
		  close(){
		   	this.drawer = false;
		  },
		  //time
      changeEnd(){
        //如果结束日期尚未选择
        if(!this.classStartTime){
          this.$message.warning('请先选择开始日期')
          this.endDateLimit = Object.assign({},this.endDateLimit,{
            disabledDate:(date)=>{
              return true
            }
          })
        }else{
          this.endDateLimit = Object.assign({},this.endDateLimit,{
            disabledDate: (time) => {
              if(this.classStartTime){
                return time.getTime() < new Date(this.classStartTime).getTime() - 1*24*60*60*1000;//可以选择同一天
              }
            }
          })
        }
      },
      setTime(){
        if(this.classEndTime){
          if(this.classStartTime > this.classEndTime){
            this.classEndTime = ''
            this.$message.warning('结束日期小于开始日期，请重新选择')
            return ;
          }
        }
      },
      // 处理班级状态
      handleClassStatus(status){
      	let str = '';
      	switch (status){
      		case 0:
      		str = '未开始';
      			break;
      		case 1:
      		str = '进行中';
      			break;
      		case 2:
      		str = '已结束';
      			break;
      		default:
      			break;
      	}
      	return str;
      },
      // 进入学员管理
      intoStudent(item){
      	this.$router.push({
      		path:'/studentAdmin',
      		query:{
      			classId: item.classId,
      			courseId: item.courseId,
      			className: item.className,
      			index: 'first',
      			subjectId: item.subjectId
      		}
      	})
      },
      // 进入小组管理
      intoGroup(item){
      	this.$router.push({
      		path:'/groupAdmin',
      		query:{
      			classId: item.classId,
      			courseId: item.courseId,
      			className: item.className,
      			index: 'first',
      			subjectId: item.subjectId
      		}
      	})
      }
		}
	}
</script>

<style lang="scss" scoped>
	.teachclass_wrap {
		height: 100%;
		.seach_ipt {
			/deep/ .el-input {
				width: 298px;
				float: left;
				.el-input__inner {
					height: 32px;
					line-height: 32px;
					border: 0;
					background: #F1F2F4;
					border-radius: 2px;
				}
			}
			.select {
				float: left;
				width: 230px;
				height: 32px;
				background: #F1F2F4;
				margin-left: 16px;
				border-radius: 2px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				span {
					font-size: 12px;
					color: #A0A0A6;
					margin-left: 14px;
				}
				i {
					width:0px;
					height:16px;
					border:1px solid rgba(188,188,194,1);
				}
				/deep/ .el-input {
					width: 126px;
					.el-input__icon {
						line-height: 32px;
					}
				}
			}
			.el-button {
				padding: 8px 12px;
				margin-left: 14px;
			}
		}
		.table {
			margin-top: 12px;
			overflow-y: auto;
			.header_title {
				display: flex;
				align-items: center;
				justify-content: space-between;
				p {
					font-size:12px;
          color:rgba(93,100,110,1);
          text-align: center;
          &:nth-child(1){ width: 70px; }
          &:nth-child(2){ flex: 1; text-align: left; padding: 0 16px; box-sizing: border-box; }
          &:nth-child(3){ width: 10%; }
          &:nth-child(4){ width: 10%; }
          &:nth-child(5){ width: 20%; }
          &:nth-child(6){ width: 10%; padding: 0 16px; box-sizing: border-box;}
          &:nth-child(7){ width: 200px; }
				}
				img {
					display: inline-block;
					width: 12px;
					height: 12px;
					margin-left: 2px;
				}
			}
			.teach_class {
				.tab_item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					height:40px;
					background:rgba(246,248,251,1);
					border-radius:4px;
					margin: 8px 0;
					&:hover {
						background: #E9EEF5;
					}
					p {
						font-size:12px;
	          color: #0D141E;
	          text-align: center;
	          &:nth-child(1){ width: 70px; }
	          &:nth-child(2){ flex: 1; text-align: left; padding: 0 16px; box-sizing: border-box; }
	          &:nth-child(3){ width: 10%; }
	          &:nth-child(4){ width: 10%; }
	          &:nth-child(5){ width: 20%; }
	          &:nth-child(6){ width: 10%; padding: 0 16px; box-sizing: border-box; color: #5397F7;}
	          &:nth-child(7){ width: 200px; }
					}
					.operation {
						display: flex;
						justify-content: space-around;
						cursor: pointer;
						span {
							color: #545A64;
							font-size: 12px;
							&:hover {
								color: #5397F7;
							}
						}
					}
				}
			}
		}
		/deep/ .el-drawer {
			width: 480px !important;
		}
		.drawer_content {
			header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 64px;
				border-bottom: 2px solid #DDE0E2;
				padding: 0 20px;
				span {
					font-size: 16px;
					color: #0D141E;
				}
				img {
					display: block;
					width: 26px;
					height: 26px;
					cursor: pointer;
				}
			}
			.ipt {
				padding: 20px 16px;
				p {
					font-size: 12px;
					margin-bottom: 12px;
				}
				/deep/ .ipt_name {
					width: 440px;
					float: left;
					.el-input__inner {
						height: 42px;
						line-height: 42px;
						border: 0;
						background: #F1F2F4;
						border-radius: 4px;
					}
				}
				.time_block {
					/deep/ .el-input {
						width: 200px;
						.el-input__inner {
							height: 42px;
							line-height: 42px;
							border: 0;
							background: #F1F2F4;
							border-radius: 4px;
						}
					}
				}
			}
			.ipt_data {
				margin-top: 10px;
			}
			.btn {
				text-align: center;
				margin-top: 50%;
				.el-button {
					padding: 7px 23px;
					margin-left: 0;
					margin-right: 15px;
				}
			}
		}
		.noList {
			display: flex;
			flex-direction: column;
			align-items: center;
			img {
				display: inline-block;
				margin-top: 10%;
				width: 250px;
				height: 170px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/TeachClass/components/teachClass.vue